import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormDiamond: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconFormDiamond"><Path d="M10.2321 2.56082C11.2084 1.58471 12.791 1.58471 13.7672 2.56082L21.4391 10.2327C22.4149 11.209 22.4151 12.7917 21.4391 13.7678L13.7672 21.4397C12.7911 22.4157 11.2084 22.4155 10.2321 21.4397L2.56021 13.7678C1.5841 12.7916 1.5841 11.209 2.56021 10.2327L10.2321 2.56082Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormDiamond;
